import type { FC } from 'react';
import Circle from './components/Circle/Circle';
import { STATUS_VARIANTS, statusVariants } from './BordStatus.type';
import BordOneToneIcon from '../BordOneToneIcon/BordOneToneIcon';
import useOnlyDevelopers from 'state/setOnlyDevelopers';

import '../BordStatus/BordStatus.scss';

/**
 * Props para el componente BordStatus
 * @param label - Texto a mostrar en el status
 * @param variant - Variante de estilo del status
 * @param renderJSX - Elemento JSX personalizado para reemplazar el label
 * @param customClassName - Clase CSS personalizada
 * @param showArrow - Indica si se debe mostrar la flecha
 * @param isOpen - Indica si el dropdown está abierto (cambia la dirección de la flecha)
 */
interface IBordStatusProps {
  label?: string;
  variant?: statusVariants;
  renderJSX?: JSX.Element;
  customClassName?: string;
  showArrow?: boolean;
  isOpen?: boolean;
  showCircleStatus?: boolean;
}

const BordStatus: FC<IBordStatusProps> = ({
  variant = 'default',
  label = 'Label',
  renderJSX,
  customClassName = '',
  showArrow = false,
  isOpen = false,
  showCircleStatus = true
}) => {
  const { onlyDevelopers } = useOnlyDevelopers();
  const renderVariants = {
    [STATUS_VARIANTS.default]: 'border-disabled-fg-secondary',
    [STATUS_VARIANTS.informative]: 'border-nudos-blue',
    [STATUS_VARIANTS.success]: 'border-nudos-green-300',
    [STATUS_VARIANTS.danger]: 'border-nudos-red-200',
    [STATUS_VARIANTS.alert]: 'border-yellow-700'
  };

  const renderContent = renderJSX ? renderJSX : <span>{label}</span>;

  return (
    <div
      className={`bordStatusContainer ${renderVariants[variant]} ${customClassName} ${
        showArrow ? 'cursor-pointer' : ''
      }`}
    >
      {showCircleStatus && <Circle variant={variant} />}
      {renderContent}

      {showArrow && (
        <>
          <div className="bordStatusDivider" />
          <BordOneToneIcon variant={isOpen ? 'arrowHeadUp' : 'arrowHeadDown'} standardSize={onlyDevelopers ? 12 : 14} />
        </>
      )}
    </div>
  );
};

export default BordStatus;
